// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"394eaccf4e59f2cd","5322":"4dfa2e3f2030ae9f"}[chunkId] + ".css";
};